import config from 'config/common';

// ---- SDK Interface ---- //
interface SoliticsSDK {
    loginSuccess(data: { memberId: string; brand: any; email: string; popupToken: any; branch: string }): void;
    onLogout(): void;
    onPageEnter(data: { pageName: string; customFields?: Record<string, any> }): void;
    onPageLeave(data: { pageName: string; customFields?: Record<string, any> }): void;
    emit(event: string, data: unknown): void;
}

declare global {
    interface Window {
        $solitics: SoliticsSDK;
    }
}

// ---- Service ---- //
class SoliticsService {
    private get sdk(): SoliticsSDK | null {
        if (typeof window === 'undefined') return null;
        return window.$solitics ?? null;
    }

    private get active(): boolean {
        return config.solitics.isSoliticsEnabled && !!this.sdk;
    }

    login(memberId: string, email: string): void {
        if (!this.active) return;
        this.sdk!.loginSuccess({
            memberId: memberId.toUpperCase(),
            email,
            brand: config.solitics.brand,
            popupToken: config.solitics.token,
            branch: config.solitics.branch,
        });
    }

    logout(): void {
        if (this.active) this.sdk!.onLogout();
    }

    enterPage(page: string, customFields?: Record<string, any>): void {
        if (this.active) this.sdk!.onPageEnter({ pageName: page, customFields });
    }

    leavePage(page: string, customFields?: Record<string, any>): void {
        if (this.active) this.sdk!.onPageLeave({ pageName: page, customFields });
    }
}

// ---- Factory ---- //
export const solitics = new SoliticsService();
